import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import { SaveButton } from './components/SaveButton';
import { MarketplaceAndMinisiteOnly } from '../../../AppContext/MarketplaceAndMinisiteOnly';
import { PublicCourse } from '@cademy-package/sdk-component-types';

export type ActionButtonsProps = {
    courseId: PublicCourse['_id'];
    saved: boolean;
};

export const ActionButtons: FunctionComponent<ActionButtonsProps> = ({ courseId, saved }) => {
    return (
        <div className={styles.actionButtons}>
            <MarketplaceAndMinisiteOnly>
                <SaveButton courseId={courseId} saved={saved} />
            </MarketplaceAndMinisiteOnly>
        </div>
    );
};
